import { RecentActivityResponseDto } from '@/types/dashboard.type';
import api from '../instance';
export const DashboardManagementService = {
  async getDashboardInfo() {
    try {
      const response = await api.dashboardApi.get(`/dashboard/grid-count`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching FAQ info');
    }
  },

  async getRecentActivity(): Promise<RecentActivityResponseDto> {
    try {
      const response = await api.dashboardApi.get(`/recent-activities/all-services?page=1&limit=3`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching recent activity');
    }
  },
};
